module.exports = __webpack_public_path__ + "assets/img/5_1196_big.160cc938.jpg";